import { configureStore } from "@reduxjs/toolkit";
import thunkMiddleware from "redux-thunk";
import auth from "./common/slices/auth";
import crewMember from "./common/slices/crewMember";
import customer from "./common/slices/customer";
import dailyreport from "./common/slices/dailyreport";
import document from "./common/slices/document";
import folder from "./common/slices/folder";
import scopeOfWork from "./common/slices/scopeOfWork";
import timesheet from "./common/slices/timesheet";
import location from "./common/slices/location";
import notification from "./common/slices/notification";
import user from "./common/slices/user";
import group from "./common/slices/group";
import media from "./common/slices/media";

export default configureStore({
    reducer: {
        crewMember,
        customer,
        dailyreport,
        document,
        folder,
        group,
        auth,
        scopeOfWork,
        timesheet,
        location,
        notification,
        user,
        media,
    },
    middleware: [thunkMiddleware],
});
